import { State } from "@/store/state";
import { Request } from "@/network/request";
import i18n from "@/i18n";
import toast from "@/plugins/toast";

export default class grade {
  endPoint = "teacher/grade";
  tableData = {
    data: [],
    showData: [],
    meta: {
      total: 1,
      per_page: 1,
      current_page: 1,
    },
  };
  getState = new State();

  get(params) {
    let request = new Request({
      method: "get",
      endpoint: `/${this.endPoint}`,
      token: this.token,
      params: params,
    });

    this.getState.trigger(
      async () => {
        return await request.send();
      },
      {
        onSuccess: (value) => {
          this.tableData.data = value.data;
          this.tableData.meta = value.meta;
        },
        onError: (error) => {
          console.log(error);
        },
      }
    );
  }
}

export const Grade = new grade();
